import { useQuery } from "@tanstack/react-query";
import { getCalendarEvents } from "../../api/CALENDAR/calendar";

export const useGetCalendarEvents = (startDate, endDate, userIds = []) => {
  return useQuery({
    queryKey: ["calendarEvents", startDate, endDate, userIds],
    queryFn: () => getCalendarEvents(startDate, endDate, userIds),
    enabled: !!startDate && !!endDate,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
